import { AnalyticsData } from '@/stores/analytics';
import { 
  ChartBarIcon, 
  FolderIcon,
  UserGroupIcon,
  ArrowPathIcon,
  CheckCircleIcon,
  FolderOpenIcon,
  DocumentIcon,
  HandThumbUpIcon,
  ExclamationTriangleIcon,
  CheckBadgeIcon,
  ChartPieIcon
} from '@heroicons/react/24/outline';

// Metric configuration for each section
export interface MetricConfig {
  label: string;
  value: number;
  icon: React.ComponentType<any>;
}

export interface MetricSectionConfig {
  title: string;
  color: string;
  metrics: MetricConfig[];
}

/**
 * Creates metric configurations for the analytics dashboard
 * This centralizes all metric definitions and makes them easy to maintain
 */
export function createMetricSections(data: AnalyticsData): MetricSectionConfig[] {
  return [
    {
      title: "Document Processing",
      color: "from-blue-500 to-blue-600",
      metrics: [
        {
          label: "Lines Extracted", 
          value: data.document_processing.lines_extracted,
          icon: ChartBarIcon
        },
        {
          label: "Categorizations",
          value: data.document_processing.categorizations,
          icon: FolderIcon
        }
      ]
    },
    {
      title: "Task Management",
      color: "from-purple-500 to-purple-600",
      metrics: [
        {
          label: "Tasks Assigned",
          value: data.task_management.tasks_assigned,
          icon: UserGroupIcon
        },
        {
          label: "Stages Changed",
          value: data.task_management.stages_changed,
          icon: ArrowPathIcon
        },
        {
          label: "Tasks Completed",
          value: data.task_management.tasks_completed,
          icon: CheckCircleIcon
        }
      ]
    },
    {
      title: "Disputes & Backups",
      color: "from-orange-500 to-red-500",
      metrics: [
        {
          label: "Backups Requested",
          value: data.disputes_backups.backups_requested,
          icon: FolderOpenIcon
        },
        {
          label: "Backups Received",
          value: data.disputes_backups.backups_received,
          icon: DocumentIcon
        },
        {
          label: "Disputes Won",
          value: data.disputes_backups.disputes_won,
          icon: HandThumbUpIcon
        },
        {
          label: "Disputes Filed",
          value: data.disputes_backups.disputes_filed,
          icon: ExclamationTriangleIcon
        }
      ]
    },
    {
      title: "Financial Processing",
      color: "from-green-500 to-green-600",
      metrics: [
        {
          label: "Deductions Validated",
          value: data.financial_processing.deductions_validated,
          icon: CheckBadgeIcon
        },
        {
          label: "GL Mappings Made",
          value: data.financial_processing.gl_mappings_made,
          icon: ChartPieIcon
        }
      ]
    }
  ];
}

// TODO: Re-enable when needed
// PDFs Parsed metric configuration
// {
//   label: "PDFs Parsed",
//   value: data.document_processing.pdfs_parsed,
//   icon: "🔍"
// }
